// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"Content_contentWrapper__NgiaP","collapsedWidth":"Content_collapsedWidth__29h63"};